//https://material-ui-next.com/demos/dialogs/
import React from "react";
import WarningIcon from "@material-ui/icons/Warning";
import edit from "../../icons/editpen.png";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import { Modal, Button } from "antd";
import "../EditDialog/editdialog.css";
import { Input } from "antd";

const { TextArea } = Input;

export default class EditDialog extends React.Component {
  state = {
    modal1Visible: false
  };

  handleClear = () => {
    this.props.designatedClearHandler();
  };

  handleDefault = () => {
    return this.props.switchOption
      ? this.props.designatedDefaultClassHandler()
      : this.props.designatedDefaultHandler();
  };

  setModal1Visible(modal1Visible) {
    this.setState({ modal1Visible });
    this.setState({'value':this.props.pill[this.props.fieldName]});
  }

  onOk = () => {
    this.setModal1Visible(false);
    this.props.updatePillcardObjectHandler(
      this.props.pill.id,
      this.props.fieldName,
      this.state.value
    );
    if (this.state.savenotes) {
      fetch('https://api.medbase.xyz/sendpills/save-notes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          "pill_id": this.props.pill.id,
          "special_notes": this.state.value
        })
      })
        .then(res => {
          if (res.ok) {
            console.log("SAVE success")
          } else {
            throw new Error('Post failed');
          }
        })
        .catch((error) => {
          console.log("error", error)
        });
    }

  };

  onChange = (e) => {
    this.setState({ value: e.target.value });
  }

  // todo-- add alert when pill cards are sent

  constructor(props) {
    super(props);
    this.handleAlertOpen = this.handleAlertOpen.bind(this);
    this.handleAlertClose = this.handleAlertClose.bind(this);
    this.state = {
      alert: false,
      variant: "success",
      value: this.props.pill[this.props.fieldName],
      message:
        "Pill cards sent! You will receive them within the next 15 minutes.",
      savenotes: (this.props.fieldName == "Special_Notes" && localStorage.getItem('token'))
    };
  }

  handleAlertOpen = (variant, message) => {
    this.setState({ alert: true, variant, message });
  };

  handleAlertClose = () => {
    this.setState({ alert: false });
  };

  render() {
    return (
      <div>
        {" "}
        {this.props.switchOption ? (
          ""
        ) : (
          <div class="edit-button-new" onClick={() => this.setModal1Visible(true)}>Edit</div>
          // <button onClick={() => this.setModal1Visible(true)}>
          // <div class="toggle-button-se">
          //   <img
          //     className="appbar-button"
          //     src={edit}
          //     alt="edit"
          //     height="35px"
          //   />
          // </button>
        )}
        <Modal
          title="Edit"
          centered
          visible={this.state.modal1Visible}
          onCancel={() => this.setModal1Visible(false)}
          onOk={() => this.setModal1Visible(false)}
          footer={[
            <Button key="submit" type="primary" onClick={this.onOk}>
              SAVE
            </Button>
          ]}
        >
          <div className="dialog-instructions">
            To edit this field's information, type in any changes you would like to make, and click "SAVE". If you do not wish to make any changes, click the cross to exit.
          </div>
          <TextArea
            onChange={this.onChange}
            value={this.state.value}
            rows={10}
          />
        </Modal>
      </div>
    );
  }
}

//taken from the material-ui demo: https://codesandbox.io/s/jjy3nnkrr9
const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});



// WEBPACK FOOTER //
// ./src/NavBar/EditDialog/index.js